import CustomTableList from "components/CustomTableList/CustomTableList";
import { HEADERS_TABLE_LIST } from "../../utils/constants";
import TableListItem from "./TableListItem";

const EventSignatureListTable = ({
	list,
	allCampus,
	openForm,
	openFile,
	openToggleDialog,
}) => {
	return (
		<CustomTableList
			minWidth="1140px"
			maxHeight="56vh"
			scrollColor="secondary"
			variant="secondary"
			headers={HEADERS_TABLE_LIST}
		>
			{list.map(item => (
				<TableListItem
					key={item.id}
					item={item}
					allCampus={allCampus}
					openForm={openForm}
					openFile={openFile}
					openToggleDialog={openToggleDialog}
				/>
			))}
		</CustomTableList>
	);
};

export default EventSignatureListTable;
